angular.module('impactx.datedisplay', []);